<script setup lang='ts'>
const toggleSidebar = inject('sidebarToggle', () => undefined);
</script>

<template>
	<UButton icon="i-lucide-menu" variant="ghost" size="sm" @click="toggleSidebar" />
</template>
